// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2eV8n","col":"styles_col__3gL9e"};